import React from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import { debounce, flowRight } from 'lodash'
import moment from 'moment'

import 'react-datepicker/dist/react-datepicker.css'
import Styles from './index.scss'


const FilterBox = (props) => {
  const isClearable = true
  return (
    <div className="filter-box">
      <div className="filter-content date filter-bold">
        <div className="filter-date">
          <div className="filter-title">
            Filter by Date Created
          </div>
          <div className="filter-body">
            <div className="filter-input">
              <div className="label-input">
                <span>Start Date</span>
              </div>
              <DatePicker
                className="input-date"
                selected={
                  props.filter.createdStartDate ? moment(props.filter.createdStartDate) : null
                }
                onChange={props.setFilterValue('createdStartDate', props.filter, props.sort)}
                isClearable={isClearable}
              />
            </div>
            <div className="filter-input relative">
              <span className="hyphen">-</span>
            </div>
            <div className="filter-input">
              <div className="label-input">
                <input
                  className="checkbox-enddate"
                  type="checkbox"
                  onChange={props.setFilterValue('isCreatedEndDateActive', props.filter, props.sort)}
                />
                <span>End Date</span>
              </div>
              <DatePicker
                className="input-date"
                selected={props.filter.createdEndDate ? moment(props.filter.createdEndDate) : null}
                onChange={props.setFilterValue('createdEndDate', props.filter, props.sort)}
                isClearable={isClearable}
              />
            </div>
          </div>
        </div>
        <div className="filter-date">
          <div className="filter-title">
            Filter by Last Updated
          </div>
          <div className="filter-body">
            <div className="filter-input">
              <div className="label-input">
                <span>Start Date</span>
              </div>
              <DatePicker
                className="input-date"
                selected={
                  props.filter.updatedStartDate ? moment(props.filter.updatedStartDate) : null
                }
                onChange={props.setFilterValue('updatedStartDate', props.filter, props.sort)}
                isClearable={isClearable}
              />
            </div>
            <div className="filter-input relative">
              <span className="hyphen">-</span>
            </div>
            <div className="filter-input">
              <div className="label-input">
                <input
                  className="checkbox-enddate"
                  type="checkbox"
                  onChange={props.setFilterValue('isUpdatedEndDateActive', props.filter, props.sort)}
                />
                <span>End Date</span>
              </div>
              <DatePicker
                className="input-date"
                selected={props.filter.updatedEndDate ? moment(props.filter.updatedEndDate) : null}
                onChange={props.setFilterValue('updatedEndDate', props.filter, props.sort)}
                isClearable={isClearable}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="filter-content search">
        <div className="search-bar">
          <input
            className="input"
            type="text"
            placeholder="Search by Email / Profile Name / Profile ID"
            onChange={flowRight(debounce(props.setFilterValue('searchKey', props.filter, props.sort), 300), e => e.persist() || e)}
          />
        </div>
        <div className={Styles['reset-botton-container']}>
          <button className={Styles['btn-reset']} onClick={props.resetFilter}>Reset Filter</button>
        </div>
      </div>
    </div>
  )
}

FilterBox.propTypes = {
  filter: PropTypes.shape({
    createdStartDate: PropTypes.string,
    createdEndDate: PropTypes.string,
    updatedStartDate: PropTypes.string,
    updatedEndDate: PropTypes.string,
  }).isRequired,
  sort: PropTypes.shape({}).isRequired,
  setFilterValue: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
}

export default FilterBox
